export function formatAddress(input) {
  return `${input.slice(0, 8)}...${input.slice(-6)}`;
}
